import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';


const MenuInsertBottom  = props => {
    const {
        insertBtn,
        cancelBtn,
        visible,
        setVisible
    } = props;

return (visible && ( 
        <div className="btn-area-jb">
            <div className="btn-area-l"></div>
            <ul className="file-list">
                <li>
                    <button className="btn-m cancel" onClick={() => cancelBtn()}>취소</button>
                </li>
                <li>
                    <button className="btn-m save" onClick={() => insertBtn()}>저장</button>
                </li>
            </ul>
        </div>
        )
    );
};


export default MenuInsertBottom;